"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "VictoryGroup", {
  enumerable: true,
  get: function () {
    return _victoryGroup.default;
  }
});

var _victoryGroup = _interopRequireDefault(require("./victory-group"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/victory-group/lib/index.js
// module id = 1884
// module chunks = 0